"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productGA4Event = void 0;
var ga4_1 = require("../../utils/ga4");
var productGA4Event = function (event, ga4) {
    var ga4New = {
        item_brand: ga4.itemBrand,
        item_category: ga4.itemCategory,
        item_category2: ga4.itemCategory2,
        item_category3: ga4.itemCategory3,
        item_id: ga4.itemId,
        item_name: ga4.itemName,
        item_variant: ga4.itemVariant,
        item_list_name: (0, ga4_1.getGA4Product)(ga4.item_id).item_list_name,
        price: ga4.price,
        quantity: ga4.quantity,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null }); // Очистка объекта электронной торговли.
    window.dataLayer.push({
        event: event,
        ecommerce: {
            items: [ga4New],
        },
    });
};
exports.productGA4Event = productGA4Event;
